/**
 * @description Compare recurring-plan product identity for Edit save (LYN-250).
 * Card/schedule-only saves must omit `items` so the server does not live-eval.
 *
 * @dependencies None
 * @notes Compares productId, variantId, and quantity only — not live catalog
 *   prices. A real product edit still sends `items` and the server re-prices.
 */

/**
 * @param {object} item
 * @returns {{ productId: string, variantId: string, quantity: number }}
 */
export function normalizePlanProductLine(item) {
  const raw = item || {};
  const productId = raw.productId != null ? raw.productId : raw.product_id;
  const variantId = raw.variantId != null ? raw.variantId : raw.variant_id;
  return {
    productId: productId == null ? '' : String(productId),
    variantId: variantId == null || variantId === '' ? '' : String(variantId),
    quantity: Number(raw.quantity) || 1
  };
}

/**
 * @param {Array<object>} currentItems
 * @param {Array<object>} initialItems
 * @returns {boolean}
 */
export default function planProductLinesChanged(currentItems, initialItems) {
  const current = (Array.isArray(currentItems) ? currentItems : []).map(normalizePlanProductLine);
  const initial = (Array.isArray(initialItems) ? initialItems : []).map(normalizePlanProductLine);
  if (current.length !== initial.length) {
    return true;
  }
  return current.some((line, index) => {
    const other = initial[index];
    return (
      line.productId !== other.productId
      || line.variantId !== other.variantId
      || line.quantity !== other.quantity
    );
  });
}
